import React from 'react'
import {
	Button
} from 'reactstrap'

import ModalQuantityEdit from '~/modules/modals/quantities/edit.jsx'
import ModalQuantityDelete from '~/modules/modals/quantities/delete.jsx'


// export default class RecipeQuantitiesModalList extends Reflux.Component {
export default class RecipeQuantitiesModalListRow extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			isEditing: false
		}
	}

	toggleEdit = () => {
		this.setState({ isEditing: !this.state.isEditing })
	}

	render() {
		return (this.state.isEditing === true)
			? (
				<ModalQuantityEdit
					quantityID={this.props.quantityID}
					quantityAbbrev={this.props.quantityAbbrev}
					quantity={this.props.quantity}
					cancelFunction={this.toggleEdit}
				/>
			)
			: (
				<tr>
					<td>{this.props.quantityAbbrev}</td>
					<td>{this.props.quantity}</td>
					<td>
						<Button
							onClick={this.toggleEdit}
							color="primary"
							block
						>
							Edit
						</Button>
					</td>
					<td>
						<ModalQuantityDelete
							quantityID={this.props.quantityID}
						/>
					</td>
				</tr>
			)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities/listRow.jsx